import { render, staticRenderFns } from "./Produse_list.vue?vue&type=template&id=60399152&scoped=true"
import script from "./Produse_list.vue?vue&type=script&lang=js"
export * from "./Produse_list.vue?vue&type=script&lang=js"
import style0 from "./Produse_list.vue?vue&type=style&index=0&id=60399152&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60399152",
  null
  
)

export default component.exports